import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { Table } from 'primeng/table';
import { first, shareReplay } from 'rxjs';

import { TokenService } from 'src/app/services/common/token.service';
import { VendorDashboardService } from './../../../../services/vendor-dashboard.service';
import { BOQDashboardService } from './../../../../services/boq-dashboard-service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { BaseService } from 'src/app/services/common/base.service';

@Component({
  selector: 'app-vendor-boq-pending',
  templateUrl: './vendor-boq-pending.component.html',
  styleUrls: ['./vendor-boq-pending.component.scss']
})
export class VendorBoqPendingComponent implements OnInit {
  public appId: any;
  public vendorRegId: any;
  public programId: any;
  public userId: any;

  public BOQtableData: any = [];
  public displayBOQDialog: boolean = false;
  public quantity: any;
  public isOpenforEditing: boolean = false;

  public estimatedComponentTotal: any;
  public estimatedGSTTotal: any;
  public estimatedGrandTotal: any;
  public miArea: any;

  public isTransportFree: boolean = false;

  filteredCrop: any[];
  ipAddress: any = '000.000.000';

  finalEstimationDetails: FormGroup;
  appVerificationItems: MenuItem[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];

  @ViewChild('appVerificationTable', { static: true })
  public appVerificationTable: Table;

  public clonedRowForEditing = {};

  public dialogBoxForinventory: boolean = false;
  public inventoryDataForGrid: any;
  public inventoryRowFilteredData: any;
  public totalQuantityUsed: any;
  public tableDataForReqBody: any;

  public loading: boolean = false;
  public subscriptions: any = []
  public subjectSub:any;
  public selectedYear:any;

  constructor(
    private tokenService: TokenService,
    private vendorService: VendorDashboardService,
    private boqService: BOQDashboardService,
    private messageService: MessageService,
    private _fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private router: Router,
    private cryptoJsService: CryptoJsService,
    private translateService: TranslateService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    private service: BaseService
  ) {}

  public tableData: any = [];
  public tableDataAfterModification: any = [];

  public programmeAppId: any;
  public programmeFarmerName: any;

  public crop: any = [];
  public grandTotal: any;
  public totalarea: any;
  public MIAreaCustomerror: any;

  public signaturePath: any;
  // crop: any = [
  //   {
  //     cropName: 'Wheat',
  //     cropId: 0,
  //   },
  //   {
  //     cropName: 'Rice',
  //     cropId: 1,
  //   },
  //   {
  //     cropName: 'Barley',
  //     cropId: 2,
  //   },
  // ];

  ngOnInit(): void {
    this.getIP();
    // this.appVerificationTable.filters['Status_Ar'] = [
    //   { value: 'P', matchMode: 'equals', operator: 'and' },
    // ];
    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.BOQtableData, 'Vendor_BOQ_List');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(this.BOQtableData, 'Vendor_BOQ_List');
        },
      },
    ];
    // this.loadData();
    this.loadDataAndApplyFilter();

    this.finalEstimationDetails = this._fb.group({
      // transOtherCharges: ['', Validators.required],
      plantSpacing: ['', Validators.required],
      rowSpacing: ['', Validators.required],
      latitude: ['', Validators.required],
      longitude: ['', Validators.required],
      remarks: ['', Validators.required],
      crop: ['', Validators.required],
      discountRate: [''],
      landMapPath: ['', Validators.required],
      billCopyPath: ['', Validators.required],
      // taxRate: ['', Validators.required],
      MIArea: [
        '',
        [
          Validators.required,
          Validators.min(0),
          (control: AbstractControl) => Validators.max(this.miArea)(control),
        ],
      ],
    });
  }

  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {

        
        this.selectedYear = res;
        this.loadData();
        this.appVerificationTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  get finalEstimationControls() {
    return this.finalEstimationDetails.controls;
  }

  filterCrop(event: any) {
    // console.log(event);
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.crop.length; i++) {
      const crop = this.crop[i];
      if (crop.label.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(crop);
      }
    }

    this.filteredCrop = filtered;
    // console.log(this.filteredCrop, 'FilteredCrop');
  }

  loadData() {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    this.vendorRegId = JSON.stringify(token?.officeCode);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    // this.loader.start();
    this.loading = true;
    let sub = this.boqService
      .getVendorApplicationForMIBOQ(JSON.parse(payload)?.sub, "Pending", this.selectedYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.userId = JSON.parse(payload)?.sub;
          // this.activityRecordService.activityRecord(
          //   this.userId,
          //   'MI BOQ Details',
          //   '',
          //   new Date(),
          //   'Success'
          // );

          // console.log('Response Data of BOQ table', data);
          this.BOQtableData = data;
          // this.loader.close();
          this.loading = false;
          // if (data.length > 0) {
          //   // this.appVerificationModel = data;
          //   this.BOQtableData = data;
          // }
        },
        error: (err) => {
          this.BOQtableData = [];
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(
          //   this.userId,
          //   'MI BOQ Details',
          //   '',
          //   new Date(),
          //   err
          // );

          if(err == 'Data not Found!'){
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: err,
            });
          }else{
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          }
        },
      });

      this.subscriptions.push(sub);
  }

  updateDialogtable() {
    this.tableDataAfterModification = this.tableData.map((e, i) => ({
      ...e,
      Amount: e.Price * e.Quantity,
      GSTAmount: (e.GST * e.Price * e.Quantity) / 100,
      AmountWithGST:
        e.Price * e.Quantity + (e.GST * e.Price * e.Quantity) / 100,
      id: i,
    }));
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    // this._personalDetalSer.uploadFile(data, this.userId, formcontrol)
    // .pipe(first())
    // .subscribe({
    //   next: (resp) => {
    //     if (resp.statusCode == 200) {
    //       this.finalEstimationDetails.patchValue({ [formcontrol]: resp.data });
    //       // console.log(this.finalEstimationDetails);
    //       // this.onLandMapUpload();
    //       this.messageService.add({
    //         severity: 'success',
    //         summary: 'Success',
    //         detail: 'File Uploaded with Auto Mode',
    //       });
    //     }
    //   },
    //   error: (err) => {},
    // })

    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, this.userId, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        // console.log(resp);
        if (resp.statusCode == 200) {
          this.finalEstimationDetails.patchValue({ [formcontrol]: resp.data });
          // console.log(this.finalEstimationDetails);
          // this.onLandMapUpload();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }
      });
    uploadElement.clear();
  }

  updateBOQ(row) {
    this.programmeAppId = row.appID;
    this.programmeFarmerName = row.FarmerName;

    this.getCropMaster();
    if (row.ProgrammeName == 'Portable Sprinkler') {
      this.isTransportFree = true;
    }

    // console.log('boqROW', row);
    let reqBody = {
      AppId: row.appID,
      VendorRegId: row.Vendor_Code,
      ProgramId: row.ProgramID,
    };

    this.loader.start();
    this.boqService
      .getVendorMIBOQ(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // console.log('Get Vendor Estimation Details (BOQ)', data);
          this.displayBOQDialog = true;
          this.loader.close();

          let label: any;
          this.crop.forEach((res) => {
            if (res.data === data.CropID) {
              label = res;
              return;
            }
          });
          // console.log('cropName', label);

          this.appId = data.AppID;
          this.vendorRegId = data.VendorRegId;
          this.programId = data.ProgID;

          this.signaturePath = data.SignaturePath;
          // this.vendorAssociateID = data.VandorAssociateID;
          // this.tableData = [];
          this.tableData = data.EstimationComponentDetail;
          this.updateDialogtable();
          this.calculatePrice();
          // console.log('table data befor modification', this.tableData);
          // console.log('table data after modification,', this.tableDataAfterModification);

          this.finalEstimationDetails.patchValue({
            // transOtherCharges: data.TransportOtherExpenses,
            plantSpacing: data.PlantSpacing,
            rowSpacing: data.RowSpacing,
            latitude: data.Lat,
            longitude: data.Long,
            remarks: data.Remarks,
            crop: label,
            discountRate: data.DiscountRate,
            landMapPath: data.LandMapPath,
            // taxRate: data.TaxRate,
            MIArea: data.MIArea,
          });
          this.onMIAreaChange();
          this.miArea = data.MIArea;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data Error! MI Estimation not loaded.',
          });
        },
      });
  }

  getCropMaster() {
    this.loader.start();
    this.vendorService
      .getCropMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          // console.log('Crop Master', res);
          this.crop = res;
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Crop Master not loaded.',
          });
        },
      });
  }

  calculatePrice() {
    this.estimatedComponentTotal = 0;
    this.estimatedGSTTotal = 0;
    this.estimatedGrandTotal = 0;

    this.tableDataAfterModification.forEach((element) => {
      this.estimatedComponentTotal =
        this.estimatedComponentTotal + element.Amount;

      this.estimatedGSTTotal = this.estimatedGSTTotal + element.GSTAmount;
      this.estimatedGrandTotal =
        this.estimatedGrandTotal + element.AmountWithGST;
    });
    this.onMIAreaChange();
  }
  onMIAreaChange() {
    this.grandTotal = 0;
    let MiArea = this.finalEstimationDetails.value.MIArea
      ? this.finalEstimationDetails.value.MIArea
      : 0;
    if (Number(this.totalarea) < MiArea) {
      this.MIAreaCustomerror = true;
      this.finalEstimationControls.MIArea.setErrors({
        error: 'MI Area should not be greater then former area',
      });
    } else {
      this.MIAreaCustomerror = false;
    }
    let transPortArea = this.isTransportFree ? 0 : 2500 * MiArea;
    let discount = this.finalEstimationDetails.value.discountRate
      ? this.finalEstimationDetails.value.discountRate
      : 0;
    let componentTotal = discount
      ? this.estimatedComponentTotal -
        (this.estimatedComponentTotal * discount) / 100
      : this.estimatedComponentTotal;
    this.grandTotal = componentTotal + transPortArea;
    this.estimatedGSTTotal = (componentTotal * 12) / 100;
  }

  onCloseDialog() {
    // this.finalEstimationDetails.reset();
    this.displayBOQDialog = false;
    this.isTransportFree = false;
    this.isProDataCalculated = false;
  }

  onRowEditInit(product) {
    this.isOpenforEditing = true;
    this.quantity = product.Quantity;
    this.clonedRowForEditing = { ...product };
  }

  onRowEditSave(product) {
    // console.log('this.product', product);
    product.Amount = product.Price * product.Quantity;
    product.GSTAmount = (product.Price * product.Quantity * product.GST) / 100;
    product.AmountWithGST =
      product.Price * product.Quantity +
      (product.Price * product.Quantity * product.GST) / 100;
    this.isOpenforEditing = false;
    this.calculatePrice();
    // console.log('After editing1', this.tableDataAfterModification);
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Product is updated',
    });
  }

  onRowEditCancel() {
    this.isOpenforEditing = false;
  }

  onRowDelete(rowIndex) {
    this.tableDataAfterModification = this.tableDataAfterModification.filter(
      (q, i) => rowIndex != i
    );
    this.calculatePrice();
    // console.log('data After delete', this.tableDataAfterModification);
  }

  submitFinalEstimation() {
    let value = this.finalEstimationDetails.value;

    const tableDataToPush: any = [];

    // console.log("finalllll", this.tableDataAfterModification);
    this.tableDataForReqBody = this.tableDataAfterModification;

    this.tableDataAfterModification.forEach((row) => {
      // let inventoryData = [];
      tableDataToPush.push({
        catID: row.CatID,
        componentID: row.ComponentID,
        sizeID: row.SizeID,
        quantity: row.Quantity,
        autoIdPriceTable: row.AutoIdPriceTable,
        inventory: row?.selectedInventory ? row?.selectedInventory : [],
      });
    });

    // console.log('tableDatatoPush', tableDataToPush);

    let transportOtherExpensesToSubmit: any;

    if (this.isTransportFree) {
      transportOtherExpensesToSubmit = 0;
    } else {
      transportOtherExpensesToSubmit = 2500 * value.MIArea;
    }

    let discountRate: number;
    if (value.discountRate == '' || value.discountRate == null) {
      discountRate = 0;
    } else {
      discountRate = value.discountRate;
    }
    let componentAmount =
      this.estimatedComponentTotal -
      (this.estimatedComponentTotal * discountRate) / 100;

    let finalData = {
      appID: this.appId,
      vendorRegId: this.vendorRegId,
      progID: this.programId,
      componentAmount: componentAmount,
      //hardcoded
      vendorAssociateID: JSON.stringify(this.vendorRegId),
      // vendorAssociateID: this.vendorRegId,
      transportOtherExpenses: transportOtherExpensesToSubmit,
      taxRate: this.estimatedGSTTotal,
      // maxSubsidyAmount:
      discountRate: discountRate,
      miArea: value.MIArea,
      landMapPath: value.landMapPath,
      billCopyPath: value.billCopyPath,
      lat: value.latitude,
      long: value.longitude,
      plantSpacing: value.plantSpacing,
      rowSpacing: value.rowSpacing,
      cropID: value.crop.data,
      remarks: value.remarks,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
      estimationComponentDetail: tableDataToPush,
      ProData_MaxSubsidy: this.proCalculatedData.maxSubsidy,
    };

    // console.log([finalData], 'PostData');

    let reqBody = [finalData];
    this.insertVendorBOQ(reqBody);
    this.tableDataAfterModification = [];
    this.finalEstimationDetails.reset();
    this.displayBOQDialog = false;
    this.isTransportFree = false;
  }

  insertVendorBOQ(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    // this.loader.start();
    this.loading = true;
    this.boqService
      .insertVendorBOQ(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          // this.activityRecordService.activityRecord(this.userId, 'MI BOQ Action', this.programmeAppId, new Date(), data, reqBody.map(val => ({...val, tableDataForReqBody: this.tableDataForReqBody})));

          // console.log('VendorMIBOQUpdatedSuccessfull', data);
          if (data.startsWith('S')) {
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: data,
            });
            this.loadData();
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Status',
              detail: data,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          // this.activityRecordService.activityRecord(this.userId, 'MI BOQ Action', this.programmeAppId, new Date(), err, reqBody.map(val => ({...val, tableDataForReqBody: this.tableDataForReqBody})));

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data Error! BOQ Estimation Not Added',
          });
        },
        complete: () => {
          this.tableDataForReqBody = null;
          // this.messageService.add({
          //   severity: 'success',
          //   summary: 'Success',
          //   detail: 'BOQ Estimation Added Successfully',
          // });
        },
      });
  }

  public showProDataCalError: boolean = false;
  public isProDataCalculated: boolean = false;
  public proCalculatedData: any;

  proDataCalculation() {
    const tableDataToPush: any = [];
    this.tableDataAfterModification.forEach((row) => {
      tableDataToPush.push({
        cat: JSON.stringify(row.CatID),
        // cat: typeof(row.CatID) == 'string' ? row.CatID :JSON.stringify(row.CatID),
        component: row.ComponentName,
        size: row.Size,
        quantity: row.Quantity,
        // price:  typeof(row.Price) == 'string' ? row.Price :JSON.stringify(row.Price)
        price: row.Price,
      });
    });

    if (!this.finalEstimationControls?.MIArea?.errors?.required) {
      this.showProDataCalError = false;
      let finalDataToPost = {
        estimationComponentDetail: tableDataToPush,
        programId: this.programId,
        applicationId: this.appId,
        vendorId: JSON.stringify(this.vendorRegId),
        rowSpacing: this.finalEstimationDetails.value.rowSpacing,
        plantSpacing: this.finalEstimationDetails.value.plantSpacing,
        area: this.finalEstimationDetails.value.MIArea,
      };
      let reqBody = finalDataToPost;

      // console.log('final Data to post', reqBody);
      this.getMaxSubsidy(reqBody);
    } else {
      this.showProDataCalError = true;
    }
  }

  getMaxSubsidy(reqBody) {
    this.loader.start();
    this.vendorService
      .getMaxSubsidyEstimate(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // console.log('getMaxSubsidy', data);
          this.proCalculatedData = data;
          this.loader.close();
          this.isProDataCalculated = true;
          // this.messageService.add({
          //   severity: 'info',
          //   summary: 'Status',
          //   detail: data,
          // });
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        // complete: () => {
        //   this.messageService.add({
        //     severity: 'success',
        //     summary: 'Success',
        //     detail: 'Estimation Updated Successfully',
        //   });
        // },
      });
  }

  selectFarmerApplication(application, statusCode) {
    if (application.appID) {
      this.router.navigate(['vendor', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(application?.appID.toString()) } });
      // let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.appID)],{ queryParams: { statusCode: statusCodeEncrypted } }));
      // window.open(link, '_blank');
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Invalid App ID',
      });
    }
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'App ID': d.appID,
          'Farmer Name': d.FarmerName,
          Village: d.village,
          Block: d.block,
          District: d.district,
          'Age Of Application': d.AgeOfApplication,
          'Programme Name': d.ProgrammeName,
          'Land Detail': d.LandDetail,
          'Total Area': d.Total_Area,
          PendingCompletedDays: d.PendingCompletedDays,
          'Current status': d.Status_Ar,
          Status: d.status,
          'Dept Remarks': d.DeptRemarks,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'appID', header: 'App ID' },
      { field: 'FarmerName', header: 'Farmer Name' },
      { field: 'village', header: 'Village' },
      { field: 'block', header: 'Block' },
      { field: 'district', header: 'District' },
      { field: 'AgeOfApplication', header: 'Age Of Application' },
      { field: 'ProgrammeName', header: 'Programme Name' },
      { field: 'LandDetail', header: 'Land Detail' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'PendingCompletedDays', header: 'Pending Completed Days' },
      { field: 'Status_Ar', header: 'Current Status' },
      { field: 'status', header: 'Status' },
      { field: 'DeptRemarks', header: 'Dept Remarks' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      });
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  rowBackgroundColor(product) {
    if (product.Status_Ar == 'P') {
      if (product.PendingCompletedDays <= -2) {
        return '#ff8080';
      } else if (product.PendingCompletedDays == -1) {
        return '#ffc966';
      }
    } else if (product.Status_Ar == 'C' || product.Status_Ar == 'A') {
      if (product.PendingCompletedDays >= -1) {
        return '#99e699';
      } else if (product.PendingCompletedDays <= -2) {
        return '#ffb3b3';
      }
    } else return '#ffffff';
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  onCloseInventoryDialog() {
    this.isOpenforEditing = false;
    this.dialogBoxForinventory = false;
    // this.inventoryDataForGrid = null;
    this.totalQuantityUsed = 0;
    // this.inventoryRowFilteredData = null;
  }

  onRowEditInitForInventory(product) {
    this.totalQuantityUsed = 0;
    product.inventory = product.inventory.map((val) => ({
      ...val,
      batchNumber_lotNo: val.batchNumber + '_' + val.lotNo,
      quantityUsed: val.quantityUsed ? val.quantityUsed : 0,
    }));
    // console.log('productForROWEDITINVENTORY', product);

    this.inventoryRowFilteredData=[];
    // this.inventoryRowFilteredData = product?.filteredInventory ? product?.filteredInventory: [];
    // if (product?.filteredInventory) {
    //   let total = 0;
    //   product?.filteredInventory.forEach((val) => {
    //     total = val?.quantityUsed;
    //   });
    //   this.totalQuantityUsed = total;
    // }
    this.inventoryDataForGrid = product;
    // console.log('this.inventoryDataForGrid', this.inventoryDataForGrid);

    // this.inventoryDataForGrid = this.inventoryDataForGrid.map(val => ({
    //   ...val,
    //   quantityUsed: val.quantityUsed ? val.quantityUsed : 0
    // }))
    this.dialogBoxForinventory = true;
  }

  onInventoryRowSelect(val) {
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach(val => {
      this.totalQuantityUsed += val.quantityUsed
    })

    this.messageService.add({
      severity: 'info',
      summary: 'Row Selected',
      detail: `Total Selected Row: ${
        this.inventoryRowFilteredData?.length
          ? this.inventoryRowFilteredData?.length
          : 0
      }`,
    });
  }

  onInventoryRowUnselect(val) {
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach(val => {
      this.totalQuantityUsed += val.quantityUsed
    })

    this.messageService.add({
      severity: 'info',
      summary: 'Row Unselected',
      detail: `Total Selected Row: ${
        this.inventoryRowFilteredData?.length
          ? this.inventoryRowFilteredData?.length
          : 0
      }`,
    });
  }

  onHeaderCheckboxToggle(val) {
    // console.log('toggle', val);
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach(val => {
      this.totalQuantityUsed += val.quantityUsed
    })

    if (val?.checked) {
      this.messageService.add({
        severity: 'info',
        summary: 'All Row Selected',
        detail: `Total Selected Row: ${
          this.inventoryRowFilteredData?.length
            ? this.inventoryRowFilteredData?.length
            : 0
        }`,
      });
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'All Row Unselected',
        detail: `Total Selected Row: ${
          this.inventoryRowFilteredData?.length
            ? this.inventoryRowFilteredData?.length
            : 0
        }`,
      });
    }
  }

  onEditComplete(row) {
    // console.log("changesd", row)
    

    // console.log("this.inventoryDataForGrid", this.inventoryDataForGrid)
    // console.log("inventoryRowFilteredData", this.inventoryRowFilteredData)
    if(this.inventoryRowFilteredData?.length !=0){
      this.inventoryRowFilteredData.forEach((val, i) => {
        // console.log(val?.batchNumber_lotNo, row?.batchNumber_lotNo)
        if(val?.batchNumber_lotNo== row?.batchNumber_lotNo){
          this.inventoryRowFilteredData[i]= row;
          return;
        }
      })
    }


    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach(val => {
      this.totalQuantityUsed += val.quantityUsed
    })
  }

  submitInventoryDetails() {
    this.onCloseInventoryDialog();
    // console.log('inventoryRowFilteredData', this.inventoryRowFilteredData);
    // console.log('inventoryDataForGrid', this.inventoryDataForGrid);

    this.inventoryDataForGrid = [this.inventoryDataForGrid].map((val) => ({
      ...val,
      // filteredInventory: this.inventoryRowFilteredData,
      selectedInventory: this.inventoryRowFilteredData.map((val) => ({
        batchNumber: val?.batchNumber,
        lotNo: val?.lotNo,
        quantityUsed: val?.quantityUsed,
      })),
    }));

    this.totalQuantityUsed = 0;
    if (this.inventoryRowFilteredData?.length == 0) {
      this.totalQuantityUsed = 0;
    } else {
      this.inventoryRowFilteredData.forEach((val) => {
        this.totalQuantityUsed += val.quantityUsed;
      });
    }

    // console.log(this.totalQuantityUsed, 'totalqunatity used')

    this.inventoryDataForGrid[0].Quantity = this.totalQuantityUsed;
    this.inventoryDataForGrid[0].Amount =
      this.inventoryDataForGrid[0].Price * this.totalQuantityUsed;
    this.inventoryDataForGrid[0].GSTAmount =
      (this.inventoryDataForGrid[0].Price *
        this.totalQuantityUsed *
        this.inventoryDataForGrid[0].GST) /
      100;
    this.inventoryDataForGrid[0].AmountWithGST =
      this.inventoryDataForGrid[0].Price * this.totalQuantityUsed +
      (this.inventoryDataForGrid[0].Price *
        this.totalQuantityUsed *
        this.inventoryDataForGrid[0].GST) /
        100;

    // console.log('finalllll', this.inventoryDataForGrid[0]);

    let index = this.inventoryDataForGrid[0]?.id
      ? this.inventoryDataForGrid[0]?.id
      : 0;
    // console.log(index, '@@@');
    if (index != null) {
      // console.log('index', index, this.inventoryDataForGrid[0]);
      this.tableDataAfterModification[index] = this.inventoryDataForGrid[0];
    }

    // console.log(this.tableDataAfterModification, 'final');

    this.calculatePrice();
  }
}

